import React from 'react';
import ReactDOM from 'react-dom/client';
import { LicenseInfo } from '@mui/x-license';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import './i18n';
import App from './App';

// Set MUI X Pro license key
LicenseInfo.setLicenseKey('26bc1c9afea66ae855b44b0d9490e27cTz0xMjUxNzksRT0xODAxNjk5MTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
